<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '终端设备编辑' : '终端设备创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="英文名称" prop="hostname">
        <a-input
          v-model="form.hostname"
          :max-length="128"
          placeholder="只允许使用字母、数字、空格、点、破折号和下划线。"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item prop="groups">
        <group-select v-model="form.groups" source-type="network_device"></group-select>
        <question-icon
          slot="label"
          title="所属群组"
          description="用于分组查询及告警配置"
        ></question-icon>
      </a-form-model-item>
      <a-form-model-item
        label="设备类型"
        prop="deviceType"
        :rules="[
          {
            message: '请选择设备类型',
            required: true,
            trigger: 'change'
          }
        ]"
        :wrapper-col="{
          span: 20
        }"
      >
        <a-select
          v-model="form.deviceType"
          :disabled="true"
          :options="selectOptions"
        ></a-select>
      </a-form-model-item>
      <a-form-model-item label="监控地址" prop="monitorAddress">
        <a-input
          v-model="form.monitorAddress"
          :disabled="isUpdate && !isClone"
          :max-length="128"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="代理" prop="proxyId">
        <a-select v-model="form.proxyId" :options="proxies"></a-select>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMonitorProxyList } from '@/api/monitor'
import {
  getNetworkDevice,
  updateNetworkDevice,
  createNetworkDevice
} from '@/api/network-device'
import QuestionIcon from '@/components/icon/QuestionIcon'
import GroupSelect from '@/components/select/GroupSelect'

export default {
  name: 'TerminalInputDrawer',
  components: {
    GroupSelect,
    QuestionIcon
  },
  data () {
    return {
      visible: false,
      isUpdate: false,
      loading: false,
      isClone: false,
      agents: [
        {
          title: 'Linux 内核版本 2.12 及以上, 64 位',
          filename: 'opseye_monitor_agent_linux.tar.gz'
        },
        {
          title: 'Windows Server 2008 r2 及以上, 64 位',
          filename: 'opseye_monitor_agent_windows.zip'
        }
      ],
      form: {
        id: '',
        name: '',
        hostname: '',
        groups: undefined,
        monitorAddress: '',
        deviceType: 'terminal',
        vendor: 'unknown',
        monitorPort: 161,
        snmpVersion: 'snmp_v2c',
        templateId: '',
        proxyId: ''
      },
      rules: {
        name: [
          {
            message: '请输入名称',
            required: true,
            trigger: 'blur'
          }
        ],
        hostname: [
          {
            message: '请输入英文名称',
            required: true,
            trigger: 'blur'
          }
        ],
        monitorAddress: [
          {
            message: '请输入 IP 地址',
            required: true,
            trigger: 'blur'
          }
        ],
        groups: [
          {
            message: '请选择所属群组',
            required: true,
            trigger: 'select'
          }
        ]
      },
      selectOptions: [
        { title: this.$t('source_type.terminal'), value: 'terminal' }
      ],
      proxies: []
    }
  },
  mounted () {
    getMonitorProxyList().then(res => {
      this.proxies = res.data.data.map(item => {
        return {
          title: item.name,
          value: item.id
        }
      })
    })
  },
  methods: {
    show (id, isClone = false) {
      if (id) {
        this.isUpdate = true
        this.isClone = isClone
        getNetworkDevice(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              name: data.name,
              hostname: data.hostname,
              groups: data.groups,
              monitorAddress: data.monitor_address,
              deviceType: 'terminal',
              vendor: 'unknown',
              monitorPort: 161,
              snmpVersion: 'snmp_v2c',
              templateId: '',
              proxyId: data.proxy_id
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        name: '',
        hostname: '',
        groups: undefined,
        monitorAddress: '',
        deviceType: 'terminal',
        vendor: 'unknown',
        monitorPort: 161,
        snmpVersion: 'snmp_v2c',
        templateId: '',
        proxyId: ''
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            name: this.form.name,
            hostname: this.form.hostname,
            device_type: 'terminal',
            vendor: this.form.vendor,
            monitor_port: 161,
            snmp_version: this.form.snmpVersion
          }
          if (this.form.groups) {
            params.group_ids = this.form.groups.map(group => group.id)
          }
          if (this.form.proxyId) params.proxy_id = this.form.proxyId
          this.loading = true
          if (this.isUpdate && !this.isClone) {
            updateNetworkDevice(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            params.monitor_address = this.form.monitorAddress
            createNetworkDevice(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
